import { RenderVideoController } from './render-video-dialog.controller'

function renderVideoDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/render-video/render-video-dialog.html?$$REVISION$$',
    controller: RenderVideoController
  }
}

export { renderVideoDialog }
